import React from 'react'
import PropTypes from 'prop-types'

import './details-preview-item.pcss'

const DetailsPreviewItem = ({ title, value, label, valueRender, className = '', renderEmpty = () => null }) => {
    return (
        <div className={`details-preview-item ${className}`}>
            {title && <div className="details-preview-item__title">{title}</div>}
            {label && <label>{label}</label>}
            <div className="details-preview-item__data">
                {!value ? renderEmpty() : (
                    <span>{valueRender ? valueRender(value) : value}</span>
                )}
            </div>
        </div>
    )
}

DetailsPreviewItem.propTypes = {
    title: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    renderEmpty: PropTypes.func,
}

export default DetailsPreviewItem
